module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/index/avatar-doctor-m-6c9b150889962105910a094e3113348a.png";